<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.FaqSlice>());

const openIndex = ref<number | null>(null)

function toggle(index: number) {
  openIndex.value = openIndex.value === index ? null : index
}
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-faq', 'pa-faq--' + slice.variation]"
  >
    <div class="pa-container">
      <div class="pa-faq__inner">
        <div v-if="slice.primary.heading" class="pa-faq__heading">
          <PrismicRichText :field="slice.primary.heading" />
        </div>

        <div class="pa-faq__list">
          <div
              v-for="(item, index) in slice.primary.items"
              :key="index"
              class="pa-faq__item"
              :class="{ 'pa-faq__item--open': openIndex === index }"
          >
            <button
                class="pa-faq__item-question"
                @click="toggle(index)"
            >
              <span>{{ item.question }}</span>
              <svg
                  v-if="openIndex !== index"
                  class="pa-faq__item-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              <svg
                  v-else
                  class="pa-faq__item-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
              </svg>
            </button>
            <div class="pa-faq__item-answer">
              <div class="pa-faq__item-answer-inner">
                <PrismicRichText :field="item.answer" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
